import React from "react";
import * as Yup from 'yup';
import { ModelloClimaDataDto } from "../../generated"
import { MarcaCaldaiaSelectorFree } from "../../marcheClima/components/modelliClimaSelector";

import { Forms } from "../../common/components/CmForms";
const { Form, FormText, ActionBar } = Forms<ModelloClimaDataDto>()

interface Props {
    modelloClima?: ModelloClimaDataDto;
    onSubmit: (modelloClima: ModelloClimaDataDto) => void;
    onCancel: () => void;
}

export default class ModelloClimaForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<ModelloClimaDataDto>>({
        marca: Yup
            .string()
            .required('Campo obbligatorio'),
        modello: Yup
            .string()
            .required('Campo obbligatorio'),
    })

    render() {
        const { modelloClima } = this.props;
        if (!modelloClima)
            return null;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={modelloClima}
                validationSchema={ModelloClimaForm.validationSchema}
            >
                {
                    ({ values, set, errors }) =>
                        <div className="card card-outline-info">
                            <div className="card-header text-white">Dati Modello Clima</div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <MarcaCaldaiaSelectorFree
                                            onChange={value => set("marca", value ?? undefined)}
                                            value={values.marca ?? null}
                                            label="Marca"
                                            error={errors.marca}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <FormText
                                            name="modello"
                                            label="Modello"
                                        />
                                    </div>
                                </div>
                                <ActionBar
                                    onCancel={this.props.onCancel}
                                />
                            </div>
                        </div>
                }
            </Form>
        );
    }
}
